<template>
  <div class="fullheight">
    <div class="modal" :class="modal.show ? 'is-active' : ''">
      <div
        class="modal-background"
        style="background-color: rgba(10, 10, 10, 0.33)"
        @click="modal.show = false"
      ></div>
      <div class="modal-card">
        <section
          class="modal-card-body"
          style="border-radius: 5px"
          v-html="modal.html"
        ></section>
      </div>
      <button
        class="modal-close is-large"
        aria-label="close"
        @click="modal.show = false"
      ></button>
    </div>
    <nav
      class="mobile-only"
      role="navigation"
      aria-label="main navigation"
      :class="
        affil && affil == 'workingcapital' ? 'navbar-workingcapital' : 'navbar'
      "
    >
      <div class="container">
        <div class="navbar-brand">
          <a class="navbar-item" style="padding-top: 10px">
            <img
              src="../../src/assets/img/workingcapital-white-text-only-powered.png"
              id="logo"
              height="28"
              v-if="affil && affil == 'workingcapital'"
            />
            <img
              src="../../src/assets/img/cardiff-white-text-only.png"
              id="logo"
              height="28"
              v-else
            />
          </a>
        </div>
      </div>
    </nav>
    <div class="container is-fluid fullheight" id="appcontainer">
      <div class="columns fullheight is-centered">
        <div class="column is-one-quarter" id="cardiff-column" v-if="page < 12">
          <div
            id="sidebarlogo"
            style="width: 100px; margin: auto; margin-bottom: 20px"
          >
            <img
              src="../../src/assets/img/workingcapital-square.png"
              style="border-radius: 10px"
              v-if="affil && affil == 'workingcapital'"
            />
            <img
              src="../../src/assets/img/cardiff-square.png"
              style="border-radius: 10px"
              v-else
            />
            <img
              src="../../src/assets/img/poweredby.png"
              style="border-radius: 3px"
              v-if="affil"
            />
          </div>
          <h4 class="has-text-centered">
            Tell us a little bit about your business.
          </h4>
          <p class="has-text-centered" style="margin-bottom: 30px">
            Fill out our 2 minute application and get an approval instantly.
          </p>
          <div style="margin: auto; width: 100%; text-align: center">
            <img
              src="../../src/assets/img/bbb.svg"
              style="max-width: 100px; margin-right: 10px; margin-left: 10px"
            />
            <img
              src="../../src/assets/img/ssl.svg"
              style="max-width: 100px; margin-right: 10px"
            />
          </div>
        </div>
        <div class="column" id="app-column">
          <transition name="slide" mode="out-in">
            <div
              class="tabs is-small is-centered is-fullwidth"
              :class="scrolled ? 'fixed-tabs' : ''"
              v-if="page < 9"
            >
              <ul>
                <li
                  :class="page < 3 ? 'is-active' : ''"
                  style="margin-top: 0px"
                >
                  <a>Basic Information</a>
                </li>
                <li
                  :class="page > 2 && page < 6 ? 'is-active' : ''"
                  style="margin-top: 0px"
                >
                  <a>Ownership</a>
                </li>
                <li
                  :class="page > 5 ? 'is-active' : ''"
                  style="margin-top: 0px"
                >
                  <a>Finances</a>
                </li>
              </ul>
            </div>
          </transition>
          <div
            style="max-width: 600px; margin: auto"
            :class="scrolled ? 'pushed-pages' : ''"
            v-if="!loading"
          >
            <transition name="slide" mode="out-in">
              <GetStarted
                v-if="page == 1 && !loading"
                key="p1"
                @next="incrementPage"
                :amt="$route.params.amt"
              />
              <PersonalInfo v-if="page == 2" key="p2" @next="incrementPage" />
              <BusinessInfo v-if="page == 3" key="p3" @next="incrementPage" />
              <VerifyOwnership
                v-if="page == 4"
                key="p4"
                @next="incrementPage"
              />
              <Signature v-if="page == 5" key="p5" @next="incrementPage" />
              <LoanInfo v-if="page == 6" key="p6" @next="incrementPage" />
              <BankVerify
                v-if="page == 7"
                key="p7"
                @next="incrementPage"
                message="To provide an instant approval, we need to verify your business bank account information."
              />
              <Finicity
                v-if="page == 8"
                key="p8"
                @next="incrementPage"
                api="apply"
                :link="model.sfleadid"
              />
              <FinicityResult
                v-if="page == 9"
                key="p9"
                @next="incrementPage"
                :customerId="customerId"
              />
              <UploadDoc
                v-if="page == 10"
                key="p10"
                @next="incrementPage"
                doc="Photo ID"
                api="apply"
                :link="model.sfleadid"
              />
              <UploadDoc
                v-if="page == 11"
                key="p11"
                @next="incrementPage"
                doc="Voided Check"
                api="apply"
                :link="model.sfleadid"
              />
              <Approval
                v-if="page == 12"
                key="p12"
                title="Congrats!"
                :texts="finishText"
                @next="incrementPage"
              />
            </transition>
          </div>
          <div
            style="max-width: 600px; margin: auto"
            :class="scrolled ? 'pushed-pages' : ''"
            v-if="loading"
          >
            <a
              class="button is-link is-loading is-large is-fullwidth"
              key="loading"
              >Loading</a
            >
          </div>
        </div>
      </div>
    </div>
    <footer
      class="footer mobile-only"
      style="margin-top: 60px"
      v-if="page != 7 && page != 5"
    >
      <div class="content has-text-centered">
        <img
          src="../../src/assets/img/bbb.svg"
          style="margin-left: 15px; max-width: 120px"
        />
        <img
          src="../../src/assets/img/ssl.svg"
          style="margin-left: 15px; max-width: 120px; margin-right: 15px"
        />
        <p style="font-size: 0.675em; color: grey; margin-top: 10px">
          © 2024 Cardiff, Inc
        </p>
      </div>
    </footer>
  </div>
</template>

<script>
import {
  GetStarted,
  PersonalInfo,
  BankVerify,
  Finicity,
  BusinessInfo,
  FinicityResult,
  VerifyOwnership,
  Signature,
  Approval,
  UploadDoc,
  LoanInfo,
} from "@/components/apply/pages";
import { build } from "@/tools/modelBuilder";
import $ from "jquery";
export default {
  name: "Apply",
  components: {
    GetStarted,
    PersonalInfo,
    BankVerify,
    Finicity,
    BusinessInfo,
    FinicityResult,
    VerifyOwnership,
    Signature,
    Approval,
    UploadDoc,
    LoanInfo,
  },
  data() {
    return {
      page: 1,
      demo: false,
      customerId: null,
      scrolled: false,
      loading: false,
      modal: {
        show: false,
        shown: false,
        html: "",
      },
      affil: null,
      finishText: [
        { str: "You've successfully applied for financing with Cardiff!" },
        {
          str: "You can now close this page. A representative will contact you if we need any additional information.",
        },
      ],
      model: { sfleadid: null },
    };
  },
  computed: {},
  methods: {
    incrementPage: function (pageData) {
      console.log("pageData", pageData);
      this.model = build(this.model, pageData);
      if (pageData.customerId) {
        console.log("we have the customer id ", pageData.customerId);
        this.customerId = pageData.customerId;
      }
      var self = this;
      $.ajax({
        type: "POST",
        url: "/api/apply/lead",
        contentType: "application/json",
        dataType: "json",
        data: JSON.stringify({ model: self.model, page: self.page }),
      })
        .done(function (response) {
          if (response.leadid) {
            console.log("setting leadid in model", response.leadid);
            self.model.sfleadid = response.leadid;
          }
          if (response.page) {
            if (response.page == 2) {
              ttq.load("C443S04787TERR100EAG");

              fbq("track", "CompleteRegistration");
              dataLayer.push({ event: "Contact Form" });

              window.uetq = window.uetq || [];
              window.uetq.push("event", "contact_filled", {});
            }
            if (response.page == 6) {
              ttq.load("C443S04787TERR100EB0");

              dataLayer.push({ event: "Complete App" });

              window.uetq = window.uetq || [];
              window.uetq.push("event", "finished_app", {});
            }
            if (response.page == 11) {
              fbq("track", "SubmitApplication");
            }
          }
        })
        .fail(function (err) {
          console.log(err.responseText);
          self.invalid = true;
        });
      this.page++;
      window.scrollTo(0, 0);
    },
    scrollListener: function () {
      var scrollTop =
        window.pageYOffset ||
        (document.documentElement || document.body.parentNode || document.body)
          .scrollTop;
      if (scrollTop > 60) {
        this.scrolled = true;
      } else {
        this.scrolled = false;
      }
    },
    mouseListener: function (e) {
      var y = window.Event
        ? e.pageY
        : event.clientY +
          (document.documentElement.scrollTop
            ? document.documentElement.scrollTop
            : document.body.scrollTop);
      if (y < 5 && !this.modal.shown) {
        this.modal.show = true;
        this.modal.shown = true;
      }
    },
  },
  mounted: function () {
    var self = this;
    window.addEventListener("scroll", this.scrollListener);
    setTimeout(function () {
      if (window.Event) {
        document.captureEvents(Event.MOUSEMOVE);
      }
      // document.onmousemove = self.mouseListener;
    }, 10000);

    this.scrollListener();

    if (self.$route.params.provider) {
      self.affil = self.$route.params.provider;
      switch (self.affil) {
        case "workingcapital":
          document.title = "Working Capital - Powered by Cardiff";
          break;
      }
    }

    if (self.$route.params.code) {
      self.loading = true;
      self.model.sfleadid = self.$route.params.code;
      self.modal.show = true;
      self.modal.html =
        "<h2>Welcome back!</h2><p>We're loading your application so you can pick up where you left off.</p> <a class='button is-link is-loading is-large is-fullwidth'>Loading</a>";
      // figure out what page we were on

      $.ajax({
        type: "POST",
        url: "/api/apply/load-progress",
        contentType: "application/json",
        dataType: "json",
        data: JSON.stringify({ leadid: self.model.sfleadid }),
      })
        .done(function (response) {
          self.loading = false;
          if (response.page) {
            self.page = response.page;
          }
          if (response.appdata) {
            self.model.business = {};
            self.model.business.address = response.appdata.address;
            self.model.business.name = response.appdata.name;
            self.model.business.state = response.appdata.state;
          }
          setTimeout(() => {
            self.modal.show = false;
          }, 2500);
        })
        .fail(function (err) {
          console.log(err.responseText);
          alert(err.responseText);
          self.invalid = true;
          self.loading = false;
          self.modal.show = false;
          self.page = 12;
        });
    }
    if (self.$route.params) {
      self.$router.push({ path: `/apply/` });
    }
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.navbar {
  background-color: #3c5cac;
  z-index: 2;
}
.navbar-workingcapital {
  background-color: #2b286b;
  z-index: 2;
}
.navbar .navbar-brand {
  text-align: center;
  display: block;
  width: 100%;
}

.navbar .navbar-brand > .navbar-item,
.navbar .navbar-brand .navbar-link {
  display: inline-block;
}
@media screen and (min-width: 769px), print {
  .mobile-only {
    display: none;
  }
  #appcontainer {
    margin-left: 0px;
  }
  .fullheight {
    min-height: 100vh;
    /* height: 100vh; */
  }
  #app-column {
    padding: 20px 100px;
  }
  .tabs a {
    font-size: 18px;
  }
}

@media screen and (max-width: 768px) {
  #cardiff-column {
    display: none;
  }
  #app-column {
    min-height: 100vh;
  }
  .fixed-tabs {
    position: fixed;
    z-index: 2;
    background: white;
    top: 0px;
    width: 100%;
    left: 0px;
    transition: all 0.3s;
  }
  .pushed-pages {
    margin-top: 55px !important;
  }
}

.is-active {
  font-weight: bold;
}

#cardiff-column {
  /* background: #f1f1f1; */
  background: linear-gradient(
    90deg,
    rgb(246, 246, 246) 0%,
    rgb(242, 242, 242) 57%,
    rgb(237, 237, 237) 100%
  );
  z-index: 1;
  padding-top: 50px;
  max-width: 280px;
}

#logo {
  /* max-width: 50%; */
  margin: auto;
  display: block;
  /* margin-top: 10px; */
  /* margin-bottom: 10px; */
}

.next-button {
  margin-top: 10px;
}

.columns {
  margin-left: 0;
  margin-right: 0;
}

.no-margin {
  margin-bottom: 0px !important;
}
</style>
